export const AUTH_VIEW = Object.freeze({
	SIGNIN: { label: 'Sign in', value: 'SIGNIN' },
	SIGNUP: { label: 'Sign up', value: 'SIGNUP' },
	RESET_FORGOT_PASSWORD: {
		label: 'Reset Forgot Password',
		value: 'RESET_FORGOT_PASSWORD',
	},
	FORGOT_PASSWORD: {
		label: 'Forgot Password?',
		value: 'FORGOT_PASSWORD',
	},
	ENTER_CODE: { label: 'Enter OTP', value: 'ENTER_CODE' },
	SIGNUP_SUCCESS: { label: 'SignUp success', value: 'SIGNUP_SUCCESS' },
	EMAIL_SEND_SUCESS: { label: 'Email sent', value: 'EMAIL_SEND_SUCESS' },
});
